/**
 * @generated SignedSource<<cd4746523c651e56ecee740aa726ab3c>>
 * @relayHash f9849ca62d92d5dccd989e12e1008a35
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b5ee7e920ef5738fb298d664d9c2c5ee8763d21ceced2b7bc2516078b63fe195

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { NotificationLogsPageUiQuery } from './NotificationLogsPageUiQuery.graphql';

const node: PreloadableConcreteRequest<NotificationLogsPageUiQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b5ee7e920ef5738fb298d664d9c2c5ee8763d21ceced2b7bc2516078b63fe195",
    "metadata": {},
    "name": "NotificationLogsPageUiQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
